import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";

import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  Grid,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
} from "@mui/material";


import { updateSelectedUserIds } from "store/actions/account";
import { useDispatch, useSelector } from "react-redux";
import { ListCard, ListCardField, ListCards } from "components";
import useCompactLayout from "hooks/useCompactLayout";


const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  actions: {
    justifyContent: "flex-end",
  },
  textLink: {
    textDecoration: "underline",
  },
}));

const POSClientTable = (props) => {
  const { className, clientList, ...rest } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const isCompact = useCompactLayout();
  const [selectedItems, setSelectedUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const updateUserIds = (ids) => dispatch(updateSelectedUserIds(ids));
  const userFilter = useSelector((state) => state.account.filter);



  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedItems.indexOf(id);
    let newSelectedUsers = [];

    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(selectedItems, id);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }

    setSelectedUsers(newSelectedUsers);
    updateUserIds(newSelectedUsers);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const filterClients = () => {
    if (!userFilter || userFilter === null || userFilter.trim() === "") {
      return clientList;
    }

    return clientList.filter(
      (client) =>
        (client.restaurantId && client.restaurantId.toLowerCase().includes(userFilter)) ||
        (client.displayClientName && client.displayClientName.toLowerCase().includes(userFilter)) ||
        (client.userName &&  client.userName.includes(userFilter))
      
    );
  };

  const getTimeString = (date) => {
    if (typeof date === "object" && '_seconds' in date) {
      return moment(new Date(date._seconds * 1000)).format('DD/MM/YYYY')
    }
    return moment(date * 1000).format('DD/MM/YYYY HH:mm')
  };

  const getTypesString = (types) => {
    const names = types.map(type => type.tableNumber);
    return names.join(', ');
  }

  // One slice, shared by both layouts, so page state survives a resize.
  const visibleClients = filterClients();
  const pagedClients = visibleClients.slice(page * rowsPerPage, rowsPerPage * page + rowsPerPage);

  const renderCards = () => (
    <ListCards count={visibleClients.length} noun="display client" empty="No display clients to show.">
      {pagedClients.map((client) => (
        <ListCard
          key={client.id}
          data-testid="display-client-card"
          header={
            <>
              <Checkbox
                checked={selectedItems.indexOf(client.id) !== -1}
                color="primary"
                onChange={(event) => handleSelectOne(event, client.id)}
                size="small"
                inputProps={{ "aria-label": `select display client ${client.id}` }}
              />
              <Typography variant="body1">{client.displayClientName}</Typography>
            </>
          }
        >
          <ListCardField label="User" value={`${client.username} (${client.userEmail})`} />
          <ListCardField label="POS clients" value={(client.posClientNames || []).join(', ')} />
        </ListCard>
      ))}
    </ListCards>
  );

  return (
    <Grid lg={12} md={12} xl={12} xs={12}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {isCompact ? renderCards() : (
          <div className={classes.inner}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      {/* <Checkbox
                        checked={selectedItems.length === clientList.length}
                        color="primary"
                        indeterminate={
                          selectedItems.length > 0 &&
                          selectedItems.length < clientList.length
                        }
                        onChange={handleSelectAll}
                      /> */}
                    </TableCell>
                    <TableCell>Name</TableCell>
                 
                    <TableCell>User</TableCell>
                    <TableCell>POS Clients</TableCell>
                 
                   
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pagedClients
                    .map((client) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={client.id}
                        selected={
                          selectedItems.indexOf(client.id) !== -1
                        }
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={
                              selectedItems.indexOf(client.id) !== -1 
                            }
                            color="primary"
                            onChange={(event) =>
                              handleSelectOne(event, client.id)
                            }
                            value="true"
                          />
                        </TableCell>
                        <TableCell>

                   
                              <Typography
                                variant="body1"
                              
                              >
                                {" "}
                                {client.displayClientName}
                              </Typography>
                            
                         
                       
                        </TableCell>
              
                        <TableCell>{client.username} ({client.userEmail})</TableCell>
                        <TableCell>{client.posClientNames.join(', ')}</TableCell>
            
                     
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          )}
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={visibleClients.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[20, 50, 100]}
          />
        </CardActions>
      </Card>
    </Grid>
  );
};

POSClientTable.propTypes = {
  className: PropTypes.string,
  clientList: PropTypes.array.isRequired,
};

export default POSClientTable;
